export const QUERY_KEYS: Record<
  string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Record<string, (...args: any) => string[]>
> = {
  advertisements: {
    releventAdvertisement: () => ["relevantAdvertisement"],
  },
  enrolledCourses: {
    index: () => ["enrolled"],
    show: (id: number) => ["enrolled", String(id)],
  },
  feedbacks: {
    makeAllReadById: (id: number) => ["readFeedbacks", String(id)],
    counts: () => ["feedbacksCount"],
    all: () => ["allFeedbacks"],
  },
  home: {
    stats: () => ["stats"],
    ranking: () => ["ranking"],
    progress: () => ["progress"],
    lecturesStats: () => ["lecturesStats"],
    latestFeedbacks: () => ["latestFeedback"],
    topOne: () => ["topOne"],
    absenceAlert: () => ["absenceAlert"],
    missedTasksCheck: () => ["missedTasksCheck"],
  },
  notifications: {
    index: () => ["notifications"],
  },
  profileInfo: {
    arabCountries: () => ["arabCountries"],
    professions: () => ["professions"],
    governorates: (id: number) => ["governorates", String(id)],
    colleges: () => ["colleges"],
  },
  profile: {
    show: () => ["profile"],
    socialLinks: () => ["socialLinks"],
  },
  projects: {
    index: () => ["projects"],
  },
  settings: {
    index: () => ["settings"],
  },
  skills: {
    index: () => ["skills"],
  },
  surveys: {
    index: () => ["surveys"],
    show: (slug: string) => ["surveys", slug],
  },
  tickets: {
    index: () => ["tickets"],
    show: (id: number) => ["tickets", String(id)],
  },
  freeMaterials: {
    index: () => ["freeMaterials"],
    enrollments: () => ["freeMaterials", "enrollments"],
    settings: () => ["freeMaterials", "settings"],
    reviews: (courseId: number) => [
      "freeMaterials",
      "reviews",
      String(courseId),
    ],
  },
  achievements: {
    topOne: (id: number) => ["achievements", "topOne", String(id)],
  },
  certificates: {
    index: () => ["certificates"],
    show: (uuid: string) => ["certificates", uuid],
  },
}
